import {
  useLazyVisitListingQuery,
  useLazyWoundListingQuery,
  useEditWoundMutation,
  useUpdateWoundStatusMutation,
  useApproveAssessmentMutation,
  useEditAssessmentDetailsMutation,
  useLazyAssessmentListingQuery,
  useLazyWoundDetailsListQuery,
  useLazyWoundPatientDetailsListQuery,
  useLazyVisitListDownloadQuery,
} from "store/api/woundManagement";
import { fixedCacheKeys } from "utils/fixedCacheKeys";

export const useWoundManagementHook = () => {
  /** ***************** 
    @purpose : Used For handle Wound and Visit details
    @Author : INIC
    ***************** */
  const [visitListing, { data: visitListingData, isUninitialized: isVisitListUninitialized }] =
    useLazyVisitListingQuery({
      fixedCacheKey: fixedCacheKeys.GET_VISIT_LIST,
    });
  // Wound management
  const [woundListing, { data: woundListingData, isUninitialized: isWoundListUninitialized }] =
    useLazyWoundListingQuery({
      fixedCacheKey: fixedCacheKeys.GET_WOUND_LIST,
    });
  const [editWoundAssessment, { isLoading: editWoundAssessmentLoader }] = useEditWoundMutation({
    fixedCacheKey: fixedCacheKeys.EDIT_QUESTIONNAIRE,
  });

  const [updateWoundStatus, { isLoading: updateWoundStatusLoader }] = useUpdateWoundStatusMutation({
    fixedCacheKey: fixedCacheKeys.UPDATE_WOUND_STATUS,
  });

  const [approveAssessment, { isLoading: isApprovingLoding }] = useApproveAssessmentMutation();
  const [editAssessmentDetails, { isLoading: isEditingAssessment }] = useEditAssessmentDetailsMutation(); // Add the new mutation
  const [assessmentListing, { data: assessmentListingData, isUninitialized: isAssessmentListUninitialized }] =
    useLazyAssessmentListingQuery({
      fixedCacheKey: fixedCacheKeys.GET_WOUND_LIST,
    });
  const [woundDetailsList, { data: woundDetailsData, isUninitialized: isWoundDetailsListUninitialized }] =
    useLazyWoundDetailsListQuery();
  const [
    woundPatientDetailsList,
    { data: woundPatientDetailsData, isUninitialized: isWoundPatientDetailsListUninitialized },
  ] = useLazyWoundPatientDetailsListQuery();
  const [visitListDownload, { data: visitListDownloadData, isUninitialized: isVisitListDownloadUninitialized }] =
    useLazyVisitListDownloadQuery();
  return {
    visitListing,
    visitListingData,
    isVisitListUninitialized,
    woundListing,
    woundListingData,
    isWoundListUninitialized,
    editWoundAssessment,
    editWoundAssessmentLoader,
    updateWoundStatus,
    updateWoundStatusLoader,
    approveAssessment,
    isApprovingLoding,
    editAssessmentDetails,
    isEditingAssessment,
    assessmentListing,
    assessmentListingData,
    isAssessmentListUninitialized,
    woundDetailsList,
    woundDetailsData,
    isWoundDetailsListUninitialized,
    woundPatientDetailsList,
    isWoundPatientDetailsListUninitialized,
    woundPatientDetailsData,
    visitListDownload,
    visitListDownloadData,
    isVisitListDownloadUninitialized,
  };
};
